/**
 * Toast notification utilities
 * These are initialized with the store's dispatch function via initToastHelpers()
 */
let _dispatch = null;
const toastHelperNotInitialized =
  'Toast helpers not initialized. Call initToastHelpers(dispatch) first.';

/**
 * Initialize toast helpers with the store's dispatch function
 * This should be called once when the store is created
 * @param {Function} dispatch - Vuex store dispatch function
 */
export const initToastHelpers = dispatch => {
  _dispatch = dispatch;
};

/**
 * Show an error toast notification
 * @param {string} message - Error message to display
 */
export const showErrorToast = message => {
  if (!_dispatch) {
    console.error(toastHelperNotInitialized);
    return;
  }
  _dispatch('toastr/error', message, { root: true });
};

/**
 * Show a success toast notification
 * @param {string} message - Success message to display
 */
export const showSuccessToast = message => {
  if (!_dispatch) {
    console.error(toastHelperNotInitialized);
    return;
  }
  _dispatch('toastr/success', message, { root: true });
};

/**
 * Show a warning toast notification
 * @param {string} message - Warning message to display
 */
export const showWarningToast = message => {
  if (!_dispatch) {
    console.error(toastHelperNotInitialized);
    return;
  }
  _dispatch('toastr/warning', message, { root: true });
};

/**
 * Show an info toast notification
 * @param {string} message - Info message to display
 */
export const showInfoToast = message => {
  if (!_dispatch) {
    console.error(toastHelperNotInitialized);
    return;
  }
  _dispatch('toastr/info', message, { root: true });
};
